/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserSetting } from './UserSetting';
import {
    UserSettingFromJSON,
    UserSettingFromJSONTyped,
    UserSettingToJSON,
} from './UserSetting';

/**
 * Extends outputs for "list" type operations to return pagination details
 * @export
 * @interface ListSettingsResponseContent
 */
export interface ListSettingsResponseContent {
    /**
     * Pass this in the next request for another page of results
     * @type {string}
     * @memberof ListSettingsResponseContent
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<UserSetting>}
     * @memberof ListSettingsResponseContent
     */
    settings: Array<UserSetting>;
}


/**
 * Check if a given object implements the ListSettingsResponseContent interface.
 */
export function instanceOfListSettingsResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "settings" in value;

    return isInstance;
}

export function ListSettingsResponseContentFromJSON(json: any): ListSettingsResponseContent {
    return ListSettingsResponseContentFromJSONTyped(json, false);
}

export function ListSettingsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSettingsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextToken': !exists(json, 'nextToken') ? undefined : json['nextToken'],
        'settings': ((json['settings'] as Array<any>).map(UserSettingFromJSON)),
    };
}

export function ListSettingsResponseContentToJSON(value?: ListSettingsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextToken': value.nextToken,
        'settings': ((value.settings as Array<any>).map(UserSettingToJSON)),
    };
}

